import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import store from '@/store'
import message from '@/components/message'
import { formatCodenamesCall } from '@/services/posts'
import { sendEmail } from '@/services/email'
import { forEach } from 'lodash'
import { generateCronExpression } from '@/services/socialNetworkTools'

const baseURL = processEnvConfig.VUE_APP_HYPER_ESPACE_API_URL

const stateDefault = () => ({
  finished: false,
  editModal: false,
  loadingStatusTextIa: false,
  modalConfirmBrouillonDeletePlanif: true,
  destinationSelectable: true,
  countFinished: 0,
  countBrouillons: 0,
  tempIdToDelete: null,
  picturesConverted: false,
  textLoadingCreation: '',
  loadingPublishStatus: false,
  mustUpdateDestination: false,
  post: {
    id: null,
    reference: null,
    diffusions: null,
    planifications: null,
    initial: {
      libelle: '',
      inputText: '',
      pictures: [],
      linkToVideo: null,
      iaPrompt: '',
      studioSujetId: null,
      promptUtilisateur: null,
      alreadyGeneratedAI: false
    },
    facebook: {
      inputText: '',
      libelle: '',
      pictures: [],
      linkToVideo: null,
      actionButton: null,
      urlAction: null,
      UTM: null,
      iaPrompt: null,
      datePlanif: null,
      publishNow: true,
      alreadyPublished: false,
      planned: null,
      plannedId: null,
      alreadyGeneratedAI: false,
      useAnotherPicture: false
    },
    google: {
      libelle: '',
      typePost: 'STANDARD',
      inputText: '',
      pictures: [],
      linkToVideo: null,
      actionButton: null,
      urlAction: null,
      UTM: null,
      offerLink: null,
      offerConditions: null,
      offerDateBefore: null,
      offerDateAfter: null,
      iaPrompt: null,
      datePlanif: null,
      publishNow: true,
      alreadyPublished: false,
      planned: null,
      plannedId: null,
      alreadyGeneratedAI: false,
      useAnotherPicture: false
    },
    instagram: {
      libelle: '',
      typePost: 'MEDIA',
      pictures: [],
      inputText: '',
      linkToVideo: null,
      iaPrompt: null,
      datePlanif: null,
      publishNow: true,
      alreadyPublished: false,
      planned: null,
      plannedId: null,
      alreadyGeneratedAI: false,
      useAnotherPicture: false
    },
    linkedin: {
      libelle: '',
      pictures: [],
      linkToVideo: null,
      inputText: '',
      iaPrompt: null,
      datePlanif: null,
      publishNow: true,
      alreadyPublished: false,
      planned: null,
      plannedId: null,
      alreadyGeneratedAI: false,
      useAnotherPicture: false
    },
    photos: []
  },
  customFacebook: false,
  customInstagram: false,
  customGoogle: false,
  customLinkedIn: false,
  googleCustom: false,
  facebookChecked: false,
  instagramChecked: false,
  googleChecked: false,
  linkedInChecked: false,
  libelle: null,
  texte: null,
  typePost: null,
  photo: null,
  linkToVideo: null,
  actionButton: null,
  datePlanif: null,
  promoCode: null,
  eventBefore: null,
  eventAfter: null,
  offerLink: null,
  offerTime: null,
  offerConditions: null,
  offerBefore: null,
  offerAfter: null,
  UTM: null,
  eventLink: null,
  sendToStory: null,
  typePostInstagram: null,
  state: null,
  linkToVideoInstagram: null,
  publishToStoryInstagram: null,
  modalIA: false,
  loadingStatus: false,
  loadingStatusIAGeneration: false,
  network: null,
  currentPost: null,
  redirection: false,
  modalStopCustom: false,
  stopCustomNetwork: null,
  watcherNewPic: false,
  publishButtonAvailable: true,
  draftButtonAvailable: true,
  id: null,
  networkClicked: 'initial',
  create: null,
  edit: null,
  modalConfirmPublish: false,
  modalConfirmPublishNow: false,
  loadingSendEmail: false,
  modalDeletePlanifBrouillons: false,
  modalMediaImageAndVideo: false,
  hasMediaConflict: false,
  pendingActionType: null
})

const postDefault = {
  id: null,
  reference: null,
  initial: {
    libelle: '',
    inputText: '',
    pictures: [],
    linkToVideo: null,
    iaPrompt: '',
    alreadyGeneratedAI: false
  },
  facebook: {
    inputText: '',
    libelle: '',
    pictures: [],
    linkToVideo: null,
    actionButton: null,
    urlAction: null,
    UTM: null,
    iaPrompt: null,
    datePlanif: null,
    publishNow: true,
    alreadyPublished: false,
    planned: null,
    plannedId: null,
    alreadyGeneratedAI: false,
    useAnotherPicture: false
  },
  google: {
    libelle: '',
    typePost: 'STANDARD',
    inputText: '',
    pictures: [],
    linkToVideo: null,
    actionButton: null,
    urlAction: null,
    UTM: null,
    offerLink: null,
    offerConditions: null,
    offerDateBefore: null,
    offerDateAfter: null,
    iaPrompt: null,
    datePlanif: null,
    publishNow: true,
    alreadyPublished: false,
    planned: null,
    plannedId: null,
    alreadyGeneratedAI: false,
    useAnotherPicture: false
  },
  instagram: {
    libelle: '',
    typePost: 'MEDIA',
    pictures: [],
    inputText: '',
    linkToVideo: null,
    iaPrompt: null,
    datePlanif: null,
    publishNow: true,
    alreadyPublished: false,
    planned: null,
    plannedId: null,
    alreadyGeneratedAI: false,
    useAnotherPicture: false
  },
  linkedin: {
    libelle: '',
    pictures: [],
    linkToVideo: null,
    inputText: '',
    iaPrompt: null,
    datePlanif: null,
    publishNow: true,
    alreadyPublished: false,
    planned: null,
    plannedId: null,
    alreadyGeneratedAI: false,
    useAnotherPicture: false
  },
  photos: []
}

function propagateInitialTextToNetworks (state, inputText) {
  if (state.facebookChecked && !state.customFacebook && state.post.facebook && !state.post.facebook.alreadyPublished) {
    state.post.facebook.inputText = inputText
  }
  if (state.instagramChecked && !state.customInstagram && state.post.instagram && !state.post.instagram.alreadyPublished) {
    state.post.instagram.inputText = inputText
  }
  if (state.googleChecked && !state.customGoogle && state.post.google && !state.post.google.alreadyPublished) {
    state.post.google.inputText = inputText
  }
  if (state.linkedInChecked && !state.customLinkedIn && state.post.linkedin && !state.post.linkedin.alreadyPublished) {
    state.post.linkedin.inputText = inputText
  }
}

export default {
  namespaced: true,
  state: {
    post: {
      id: null,
      reference: null,
      diffusions: null,
      planifications: null,
      initial: {
        libelle: '',
        inputText: '',
        pictures: [],
        linkToVideo: null,
        iaPrompt: '',
        studioSujetId: null,
        promptUtilisateur: null,
        alreadyGeneratedAI: false
      },
      facebook: {
        inputText: '',
        libelle: '',
        pictures: [],
        linkToVideo: null,
        actionButton: null,
        urlAction: null,
        UTM: null,
        iaPrompt: null,
        datePlanif: null,
        publishNow: true,
        alreadyPublished: false,
        planned: null,
        temporaryCaption: null,
        alreadyGeneratedAI: false,
        useAnotherPicture: false
      },
      google: {
        libelle: '',
        typePost: 'STANDARD',
        inputText: '',
        pictures: [],
        linkToVideo: null,
        actionButton: null,
        urlAction: null,
        UTM: null,
        offerLink: null,
        offerConditions: null,
        offerDateBefore: null,
        offerDateAfter: null,
        iaPrompt: null,
        datePlanif: null,
        publishNow: true,
        alreadyPublished: false,
        planned: null,
        temporaryCaption: null,
        alreadyGeneratedAI: false,
        useAnotherPicture: false
      },
      instagram: {
        libelle: '',
        typePost: 'MEDIA',
        pictures: [],
        inputText: '',
        linkToVideo: null,
        iaPrompt: null,
        datePlanif: null,
        publishNow: true,
        alreadyPublished: false,
        planned: null,
        temporaryCaption: null,
        alreadyGeneratedAI: false,
        useAnotherPicture: false
      },
      linkedin: {
        libelle: '',
        pictures: [],
        inputText: '',
        linkToVideo: null,
        iaPrompt: null,
        datePlanif: null,
        publishNow: true,
        alreadyPublished: false,
        planned: null,
        temporaryCaption: null,
        alreadyGeneratedAI: false,
        useAnotherPicture: false
      },
      photos: []
    },
    customFacebook: false,
    customInstagram: false,
    customGoogle: false,
    customLinkedIn: false,
    googleCustom: false,
    facebookChecked: false,
    instagramChecked: false,
    googleChecked: false,
    linkedInChecked: false,
    libelle: null,
    texte: null,
    typePost: null,
    photo: null,
    linkToVideo: null,
    actionButton: null,
    datePlanif: null,
    promoCode: null,
    eventBefore: null,
    eventAfter: null,
    offerLink: null,
    offerTime: null,
    offerConditions: null,
    offerBefore: null,
    offerAfter: null,
    UTM: null,
    eventLink: null,
    sendToStory: null,
    typePostInstagram: null,
    state: null,
    linkToVideoInstagram: null,
    publishToStoryInstagram: null,
    modalIA: false,
    loadingStatus: false,
    loadingStatusIAGeneration: false,
    network: null,
    currentPost: null,
    redirection: false,
    modalStopCustom: false,
    stopCustomNetwork: null,
    watcherNewPic: false,
    publishButtonAvailable: true,
    draftButtonAvailable: true,
    id: null,
    networkClicked: 'initial',
    create: null,
    edit: null,
    modalConfirmPublish: false,
    modalConfirmPublishNow: false,
    loadingSendEmail: false,
    modalDeletePlanifBrouillons: false,
    modalMediaImageAndVideo: false,
    hasMediaConflict: false,
    pendingActionType: null,
    statusMediasPost: { hasPhotos: false, hasVideoUrl: false, hasVideoUpload: false },
    uploadedVideoPath: null, // Path de la vidéo uploadée non sauvegardée
    analyzingMedias: false, // Protection contre les appels multiples
    lastAnalyzedPostId: null, // Éviter d'analyser le même post plusieurs fois
    temporaryVideosCache: null, // Cache pour éviter les appels multiples à /videos
    temporaryVideosCacheTime: null // Timestamp du cache
  },
  getters: {
    getLibelle: (state) => state.libelle,
    getTexte: (state) => state.texte,
    getTypePost: (state) => state.typePost,
    getPhoto: (state) => state.photo,
    getActionButton: (state) => state.actionButton,
    getDatePlanif: (state) => state.datePlanif,
    getPromoCode: (state) => state.promoCode,
    getEventBefore: (state) => state.eventBefore,
    getEventAfter: (state) => state.eventAfter,
    getOfferLink: (state) => state.offerLink,
    getOfferTime: (state) => state.offerTime,
    getOfferConditions: (state) => state.offerConditions,
    getOfferBefore: (state) => state.offerBefore,
    getOfferAfter: (state) => state.offerAfter,
    getModalIA: (state) => state.modalIA,
    getPostState: (state) => state.state,
    getLoadingStatus: (state) => state.loadingStatus,
    getLoadingStatusIAGeneration: (state) => state.loadingStatusIAGeneration,
    getUTM: (state) => state.UTM,
    getEventLink: (state) => state.eventLink,
    getTypePostInstagram: (state) => state.typePostInstagram,
    getState: (state) => state.state,
    getNetwork: (state) => state.network,
    getLinkToVideoInstagram: (state) => state.linkToVideoInstagram,
    getPublishToStoryInstagram: (state) => state.publishToStoryInstagram,
    getData: (state) => state.data,
    getCurrentPost: (state) => state.currentPost,
    getRedirection: (state) => state.redirection,
    getCustomFacebook: (state) => state.customFacebook,
    getCustomInstagram: (state) => state.customInstagram,
    getCustomGoogle: (state) => state.customGoogle,
    getCustomLinkedIn: (state) => state.customLinkedIn,
    getFacebookChecked: (state) => state.facebookChecked,
    getGoogleChecked: (state) => state.googleChecked,
    getInstagramChecked: (state) => state.instagramChecked,
    getLinkedInChecked: (state) => state.linkedInChecked,
    getInitial: (state) => state.initial,
    getDefaultPost: (state) => state.post,
    getModalStopCustom: (state) => state.modalStopCustom,
    getStopCustomNetwork: (state) => state.stopCustomNetwork,
    getWatcherNewPic: (state) => state.watcherNewPic,
    getPublishButtonAvailable: (state) => state.publishButtonAvailable,
    getDraftButtonAvailable: (state) => state.draftButtonAvailable,
    getId: (state) => state.post.id,
    getNetworkClicked: (state) => state.networkClicked,
    getCreate: (state) => state.create,
    getEdit: (state) => state.edit,
    getPhotos: (state) => state.post.photos,
    getPost: (state) => state.post,
    getModalConfirmPublish: (state) => state.modalConfirmPublish,
    getModalConfirmPublishNow: (state) => state.modalConfirmPublishNow,
    getLoadingSendEmail: (state) => state.loadingSendEmail,
    modalDeletePlanifBrouillons: (state) => state.modalDeletePlanifBrouillons,
    modalMediaImageAndVideo: (state) => state.modalMediaImageAndVideo,
    hasMediaConflict: (state) => state.hasMediaConflict,
    getStatusMediaPost: (state) => state.statusMediasPost,

    // Nouveau getter dynamique pour le type de média prioritaire
    getMediaType: (state) => {
      // Priorité 1: Vidéo uploadée (dans le post ou temporaire)
      if (state.statusMediasPost.hasVideoUpload) {
        return 'upload'
      }
      // Priorité 2: URL vidéo
      if (state.statusMediasPost.hasVideoUrl) {
        return 'url'
      }
      // Priorité 3: Photos (par défaut)
      return 'image'
    },

    // Getter pour savoir si on a des médias
    hasAnyMedia: (state) => {
      return state.statusMediasPost.hasPhotos ||
             state.statusMediasPost.hasVideoUrl ||
             state.statusMediasPost.hasVideoUpload
    },

    getUploadedVideoPath: (state) => state.uploadedVideoPath
  },
  mutations: {
    SET_MODAL_DELETE_PLANIF_BROUILLONS (state, payload) {
      state.modalDeletePlanifBrouillons = payload
    },
    setPublishButtonAvailable (state, value) {
      state.publishButtonAvailable = value
    },
    setDraftButtonAvailable (state, value) {
      state.draftButtonAvailable = value
    },
    setLibelle (state, libelle) {
      state.libelle = libelle
    },
    setTexte (state, texte) {
      state.texte = texte
    },
    setTypePost (state, typePost) {
      state.typePost = typePost
    },
    setPhoto (state, photo) {
      state.photo = photo
    },
    setActionButton (state, actionButton) {
      state.actionButton = actionButton
    },
    setDatePlanif (state, datePlanif) {
      state.datePlanif = datePlanif
    },
    setPromoCode (state, promoCode) {
      state.promoCode = promoCode
    },
    setEventBefore (state, eventBefore) {
      state.eventBefore = eventBefore
    },
    setEventAfter (state, eventAfter) {
      state.eventAfter = eventAfter
    },
    setOfferLink (state, offerLink) {
      state.offerLink = offerLink
    },
    setOfferTime (state, offerTime) {
      state.offerTime = offerTime
    },
    setOfferConditions (state, offerConditions) {
      state.offerConditions = offerConditions
    },
    setOfferBefore (state, offerBefore) {
      state.offerBefore = offerBefore
    },
    setOfferAfter (state, offerAfter) {
      state.offerAfter = offerAfter
    },
    setReferencePost (state, reference) {
      state.post.reference = reference
    },
    setModalIA (state, modalIA) {
      state.modalIA = modalIA
    },
    setModalConfirmPublish (state, modalConfirmPublish) {
      state.modalConfirmPublish = modalConfirmPublish
    },
    setModalConfirmPublishNow (state, modalConfirmPublishNow) {
      state.modalConfirmPublishNow = modalConfirmPublishNow
    },
    setLoadingStatus (state, loadingStatus) {
      state.loadingStatus = loadingStatus
    },
    setUTM (state, UTM) {
      state.UTM = UTM
    },
    setLoadingStatusIAGeneration (state, loadingStatusIAGeneration) {
      state.loadingStatusIAGeneration = loadingStatusIAGeneration
    },
    setNetwork (state, network) {
      state.network = network
    },
    setEventLink (state, eventLink) {
      state.eventLink = eventLink
    },
    setTypePostInstagram (state, typePostInstagram) {
      state.typePostInstagram = typePostInstagram
    },
    setLinkToVideoInstagram (state, linkToVideoInstagram) {
      state.linkToVideoInstagram = linkToVideoInstagram
    },
    setPublishToStoryInstagram (state, publishToStoryInstagram) {
      state.publishToStoryInstagram = publishToStoryInstagram
    },
    setCurrentPost (state, currentPost) {
      state.currentPost = currentPost
    },
    setPost (state, post) {
      state.post = post
    },
    resetPost (state) {
      state.post = {
        id: null,
        reference: null,
        initial: {
          libelle: '',
          inputText: '',
          pictures: [],
          linkToVideo: null,
          iaPrompt: '',
          studioSujetId: null,
          promptUtilisateur: null,
          alreadyGeneratedAI: false
        },
        facebook: {
          inputText: '',
          libelle: '',
          pictures: [],
          linkToVideo: null,
          actionButton: null,
          urlAction: null,
          UTM: null,
          iaPrompt: null,
          datePlanif: null,
          alreadyPublished: false,
          planned: null,
          plannedId: null,
          alreadyGeneratedAI: false,
          useAnotherPicture: false
        },
        google: {
          libelle: '',
          typePost: 'STANDARD',
          inputText: '',
          pictures: [],
          linkToVideo: null,
          actionButton: null,
          urlAction: null,
          UTM: null,
          offerLink: null,
          offerConditions: null,
          offerDateBefore: null,
          offerDateAfter: null,
          iaPrompt: null,
          datePlanif: null,
          alreadyPublished: false,
          planned: null,
          plannedId: null,
          alreadyGeneratedAI: false,
          useAnotherPicture: false
        },
        instagram: {
          libelle: '',
          typePost: 'MEDIA',
          pictures: null,
          inputText: '',
          linkToVideo: null,
          iaPrompt: null,
          datePlanif: null,
          alreadyPublished: false,
          planned: null,
          plannedId: null,
          alreadyGeneratedAI: false,
          useAnotherPicture: false
        },
        linkedin: {
          libelle: '',
          pictures: null,
          inputText: '',
          linkToVideo: null,
          iaPrompt: null,
          datePlanif: null,
          alreadyPublished: false,
          planned: null,
          plannedId: null,
          alreadyGeneratedAI: false,
          useAnotherPicture: false
        },
        photos: []
      }
    },
    setPhotos (state, photos) {
      state.post.initial.pictures = photos
    },
    setLinkToVideo (state, linkToVideo) {
      state.post.linkToVideo = linkToVideo
    },
    resetState (state) {
      Object.assign(state, stateDefault())
    },
    resetRedirection (state) {
      state.redirection = false
    },
    setRedirection (state, redirection) {
      state.redirection = redirection
    },
    setId (state, id) {
      state.post.id = id
    },
    setNetworkClicked (state, networkClicked) {
      state.networkClicked = networkClicked
    },
    setCustomFacebook (state, customFacebook) {
      state.customFacebook = customFacebook
    },
    setCustomInstagram (state, customInstagram) {
      state.customInstagram = customInstagram
    },
    setCustomGoogle (state, customGoogle) {
      state.customGoogle = customGoogle
    },
    setCustomLinkedIn (state, customLinkedIn) {
      state.customLinkedIn = customLinkedIn
    },
    setCreate (state, create) {
      state.create = create
    },
    setEdit (state, edit) {
      state.edit = edit
    },
    setPlanifications (state, planifications) {
      state.post.planifications = planifications
    },
    setDiffusions (state, diffusions) {
      state.post.diffusions = diffusions
    },
    setOfferDateGoogle (state, dates) {
      state.post.google.offerDateBefore = dates[0]
      state.post.google.offerDateAfter = dates[1]
    },
    setInstagramChecked (state, instagramChecked) {
      state.instagramChecked = instagramChecked
      if (instagramChecked) {
        state.post.instagram.inputText = state.post.initial.inputText
        state.post.instagram.linkToVideo = state.post.initial.linkToVideo
      } else {
        // Quand on décoche, remettre les valeurs par défaut
        state.post.instagram.inputText = ''
        state.post.instagram.linkToVideo = null
        state.post.instagram.pictures = []
        state.post.instagram.datePlanif = null
      }
    },
    setFacebookChecked (state, facebookChecked) {
      state.facebookChecked = facebookChecked
      if (facebookChecked) {
        state.post.facebook.inputText = state.post.initial.inputText
        state.post.facebook.linkToVideo = state.post.initial.linkToVideo
      } else {
        state.post.facebook.inputText = ''
        state.post.facebook.linkToVideo = null
        state.post.facebook.pictures = []
        state.post.facebook.datePlanif = null
      }
    },
    setGoogleChecked (state, googleChecked) {
      state.googleChecked = googleChecked
      if (googleChecked) {
        state.post.google.inputText = state.post.initial.inputText
        state.post.google.linkToVideo = state.post.initial.linkToVideo
      } else {
        // Quand on décoche, remettre les valeurs par défaut
        state.post.google.inputText = ''
        state.post.google.linkToVideo = null
        state.post.google.pictures = []
        state.post.google.datePlanif = null
      }
    },
    setLinkedInChecked (state, linkedInChecked) {
      state.linkedInChecked = linkedInChecked
      if (linkedInChecked) {
        state.post.linkedin.inputText = state.post.initial.inputText
        state.post.linkedin.linkToVideo = state.post.initial.linkToVideo
      } else {
        // Quand on décoche, remettre les valeurs par défaut
        state.post.linkedin.inputText = ''
        state.post.linkedin.linkToVideo = null
        state.post.linkedin.pictures = []
        state.post.linkedin.datePlanif = null
      }
    },
    checkPublishButtonState (state) {
      const user = store.getters.getUser

      // Vérifier si on a au moins un média dans le store (ce que l'utilisateur a actuellement)
      // On vérifie uniquement les médias dans le store, pas les statuts qui peuvent être obsolètes
      const hasMedia = (
        state.post.initial.pictures.length > 0 ||
        (state.post.initial.linkToVideo && state.post.initial.linkToVideo.length > 0) ||
        (state.statusMediasPost && state.statusMediasPost.hasVideoUpload)
      )

      // Vérifier si on a au moins un réseau social sélectionné et autorisé
      const hasNetworkSelected = (
        (state.facebookChecked && user.haveFacebookEdito) ||
        (state.instagramChecked && user.haveInstagramEdito) ||
        (state.googleChecked && user.haveGMBEdito) ||
        (state.linkedInChecked && user.haveLinkedInEdito)
      )

      // Vérifier si on a le libellé et le contenu
      const hasRequiredContent = (
        state.post.initial.libelle && state.post.initial.libelle.length > 0 &&
        state.post.initial.inputText && state.post.initial.inputText.length > 0
      )

      // Le bouton publier est activé si on a : libellé + contenu + média + au moins un réseau social
      if (hasRequiredContent && hasMedia && hasNetworkSelected) {
        state.publishButtonAvailable = false
      } else {
        state.publishButtonAvailable = true
      }
    },
    checkDraftButtonState (state) {
      // Vérifier si on a au moins un média dans le store (ce que l'utilisateur a actuellement)
      // On vérifie uniquement les médias dans le store, pas les statuts qui peuvent être obsolètes
      const hasMedia = (
        state.post.initial.pictures.length > 0 ||
        (state.post.initial.linkToVideo && state.post.initial.linkToVideo.length > 0) ||
        (state.statusMediasPost && state.statusMediasPost.hasVideoUpload)
      )

      // Le bouton brouillon est activé si on a : libellé + contenu + média
      if (state.post.initial.inputText && state.post.initial.libelle &&
          state.post.initial.inputText.length > 0 && state.post.initial.libelle.length > 0 &&
          hasMedia) {
        state.draftButtonAvailable = false
      } else {
        state.draftButtonAvailable = true
      }
    },
    setInitialInputText (state, inputText) {
      propagateInitialTextToNetworks(state, inputText)
      state.post.initial.inputText = inputText
    },
    setInitialIAPrompt (state, iaPrompt) {
      state.post.initial.iaPrompt = iaPrompt
    },
    setStudioSujetContext (state, { studioSujetId, promptUtilisateur }) {
      state.post.initial.studioSujetId = studioSujetId
      state.post.initial.promptUtilisateur = promptUtilisateur != null ? promptUtilisateur : ''
    },
    clearStudioSujetContext (state) {
      state.post.initial.studioSujetId = null
      state.post.initial.promptUtilisateur = null
    },
    setFacebookIAPrompt (state, iaPrompt) {
      state.post.facebook.iaPrompt = iaPrompt
    },
    setInstagramIAPrompt (state, iaPrompt) {
      state.post.instagram.iaPrompt = iaPrompt
    },
    setGoogleIAPrompt (state, iaPrompt) {
      state.post.google.iaPrompt = iaPrompt
    },
    setLinkedInIAPrompt (state, iaPrompt) {
      state.post.linkedin.iaPrompt = iaPrompt
    },
    updateInputTextInitial (state, inputText) {
      propagateInitialTextToNetworks(state, inputText)
      state.post.initial.inputText = inputText
    },
    updateLibelleInitial (state, libelle) {
      if (state.facebookChecked && !state.customFacebook) {
        state.post.facebook.libelle = libelle
      }
      if (state.instagramChecked && !state.customInstagram) {
        state.post.instagram.libelle = libelle
      }
      if (state.googleChecked && !state.customGoogle) {
        state.post.google.libelle = libelle
      }
      if (state.linkedInChecked && !state.customLinkedIn) {
        state.post.linkedin.libelle = libelle
      }
      state.post.initial.libelle = libelle
    },
    updateInputVideoInitial (state, value) {
      if (state.facebookChecked && !state.customFacebook) {
        state.post.facebook.linkToVideo = value
      }
      if (state.instagramChecked && !state.customInstagram) {
        state.post.instagram.linkToVideo = value
      }
      if (state.googleChecked && !state.customGoogle) {
        state.post.google.linkToVideo = value
      }
      if (state.linkedInChecked && !state.customLinkedIn) {
        state.post.linkedin.linkToVideo = value
      }
      state.post.initial.linkToVideo = value
    },
    updateInputVideoFacebook (state, value) {
      state.post.facebook.linkToVideo = value
      if (value !== state.post.initial.linkToVideo) {
        state.customFacebook = true
      }
    },
    updateInputVideoInstagram (state, value) {
      state.post.instagram.linkToVideo = value
      if (value !== state.post.initial.linkToVideo) {
        state.customInstagram = true
      }
    },
    updateInputVideoGoogle (state, value) {
      state.post.google.linkToVideo = value
      if (value !== state.post.initial.linkToVideo) {
        state.customGoogle = true
      }
    },
    updateInputVideoLinkedIn (state, value) {
      state.post.linkedin.linkToVideo = value
      if (value !== state.post.initial.linkToVideo) {
        state.customLinkedIn = true
      }
    },
    updateInputTextFacebook (state, value) {
      state.post.facebook.inputText = value
      if (value !== state.post.initial.inputText) {
        state.customFacebook = true
      }
    },
    updateInputTextInstagram (state, value) {
      state.post.instagram.inputText = value
      if (value !== state.post.initial.inputText) {
        state.customInstagram = true
      }
    },
    updateInputTextGoogle (state, value) {
      state.post.google.inputText = value
      if (value !== state.post.initial.inputText) {
        state.customGoogle = true
      }
    },
    updateInputTextLinkedIn (state, value) {
      state.post.linkedin.inputText = value
      if (value !== state.post.initial.inputText) {
        state.customLinkedIn = true
      }
    },
    setDefaultPost (state) {
      state.post = postDefault
    },
    setModalStopCustom (state, modalStopCustom) {
      state.modalStopCustom = modalStopCustom
    },
    setStopCustomNetwork (state, stopCustomNetwork) {
      state.stopCustomNetwork = stopCustomNetwork
    },
    setInitialValuesFacebook (state) {
      // Préserver les propriétés de planification et d'état
      const currentFacebook = state.post.facebook
      state.post.facebook = {
        libelle: state.post.initial.libelle,
        inputText: state.post.initial.inputText,
        linkToVideo: state.post.initial.linkToVideo,
        actionButton: null,
        urlAction: null,
        UTM: null,
        // Préserver les propriétés importantes
        datePlanif: currentFacebook.datePlanif,
        publishNow: currentFacebook.publishNow,
        alreadyPublished: currentFacebook.alreadyPublished,
        planned: currentFacebook.planned,
        plannedId: currentFacebook.plannedId,
        alreadyGeneratedAI: currentFacebook.alreadyGeneratedAI,
        useAnotherPicture: currentFacebook.useAnotherPicture,
        pictures: currentFacebook.pictures,
        iaPrompt: currentFacebook.iaPrompt
      }
    },
    setInitialValuesGoogle (state) {
      // Préserver les propriétés de planification et d'état
      const currentGoogle = state.post.google
      state.post.google = {
        libelle: state.post.initial.libelle,
        inputText: state.post.initial.inputText,
        linkToVideo: state.post.initial.linkToVideo,
        typePost: 'STANDARD',
        actionButton: null,
        urlAction: null,
        UTM: null,
        offerLink: null,
        offerConditions: null,
        offerDateBefore: null,
        offerDateAfter: null,
        // Préserver les propriétés importantes
        datePlanif: currentGoogle.datePlanif,
        publishNow: currentGoogle.publishNow,
        alreadyPublished: currentGoogle.alreadyPublished,
        planned: currentGoogle.planned,
        plannedId: currentGoogle.plannedId,
        alreadyGeneratedAI: currentGoogle.alreadyGeneratedAI,
        useAnotherPicture: currentGoogle.useAnotherPicture,
        pictures: currentGoogle.pictures,
        iaPrompt: currentGoogle.iaPrompt
      }
    },
    setInitialValuesInstagram (state) {
      // Préserver les propriétés de planification et d'état
      const currentInstagram = state.post.instagram
      state.post.instagram = {
        libelle: state.post.initial.libelle,
        inputText: state.post.initial.inputText,
        linkToVideo: state.post.initial.linkToVideo,
        typePost: 'MEDIA',
        // Préserver les propriétés importantes
        datePlanif: currentInstagram.datePlanif,
        publishNow: currentInstagram.publishNow,
        alreadyPublished: currentInstagram.alreadyPublished,
        planned: currentInstagram.planned,
        plannedId: currentInstagram.plannedId,
        alreadyGeneratedAI: currentInstagram.alreadyGeneratedAI,
        useAnotherPicture: currentInstagram.useAnotherPicture,
        pictures: currentInstagram.pictures,
        iaPrompt: currentInstagram.iaPrompt
      }
    },
    setInitialValuesLinkedIn (state) {
      // Préserver les propriétés de planification et d'état
      const currentLinkedIn = state.post.linkedin
      state.post.linkedin = {
        libelle: state.post.initial.libelle,
        inputText: state.post.initial.inputText,
        linkToVideo: state.post.initial.linkToVideo,
        // Préserver les propriétés importantes
        datePlanif: currentLinkedIn.datePlanif,
        publishNow: currentLinkedIn.publishNow,
        alreadyPublished: currentLinkedIn.alreadyPublished,
        planned: currentLinkedIn.planned,
        plannedId: currentLinkedIn.plannedId,
        alreadyGeneratedAI: currentLinkedIn.alreadyGeneratedAI,
        useAnotherPicture: currentLinkedIn.useAnotherPicture,
        pictures: currentLinkedIn.pictures,
        iaPrompt: currentLinkedIn.iaPrompt
      }
    },
    setWatcherNewPic (state, watcherNewPic) {
      state.watcherNewPic = watcherNewPic
    },
    setupNewPostForIA (state) {
      state.post.initial.inputText = state.post.initial.iaPrompt

      if (!state.post.facebook.inputText && state.facebookChecked) {
        state.post.facebook.inputText = state.post.facebook.iaPrompt
      }
      if (!state.post.google.inputText && state.googleChecked) {
        state.post.google.inputText = state.post.google.iaPrompt
      }
      if (!state.post.instagram.inputText && state.instagramChecked) {
        state.post.instagram.inputText = state.post.instagram.iaPrompt
      }
      if (!state.post.linkedin.inputText && state.linkedInChecked) {
        state.post.linkedin.inputText = state.post.linkedin.iaPrompt
      }
    },
    checkPublished (state) {
      if (state.post.diffusions) {
        state.post.diffusions.forEach(function (diffusion) {
          if (diffusion.advertiserPublication.portal.code === 'GOOGLE_MY_BUSINESS_EDITO' && diffusion.isCurrenltyPublished) {
            state.post.google.alreadyPublished = true
            state.customGoogle = false
          }
          if (diffusion.advertiserPublication.portal.code === 'FACEBOOK_EDITO' && diffusion.isCurrenltyPublished) {
            state.post.facebook.alreadyPublished = true
            state.customFacebook = false
          }
          if (diffusion.advertiserPublication.portal.code === 'INSTAGRAM_EDITO' && diffusion.isCurrenltyPublished) {
            state.post.instagram.alreadyPublished = true
            state.customInstagram = false
          }
          if (diffusion.advertiserPublication.portal.code === 'LINKEDIN_EDITO' && diffusion.isCurrenltyPublished) {
            state.post.linkedin.alreadyPublished = true
          }
        })
      }
    },
    checkPlanned (state) {
      if (state.post.planifications) {
        state.post.planifications.forEach(function (planif) {
          if (planif.portails[0].code === 'GOOGLE_MY_BUSINESS_EDITO') {
            state.post.google.datePlanif = planif.scheduled.cronDate
            state.post.google.planned = true
            state.post.google.plannedId = planif.id
          }
          if (planif.portails[0].code === 'FACEBOOK_EDITO') {
            state.post.facebook.datePlanif = planif.scheduled.cronDate
            state.post.facebook.planned = true
            state.post.facebook.plannedId = planif.id
          }
          if (planif.portails[0].code === 'INSTAGRAM_EDITO') {
            state.post.instagram.datePlanif = planif.scheduled.cronDate
            state.post.instagram.planned = true
            state.post.instagram.plannedId = planif.id
          }
          if (planif.portails[0].code === 'LINKEDIN_EDITO') {
            state.post.linkedin.datePlanif = planif.scheduled.cronDate
            state.post.linkedin.planned = true
            state.post.linkedin.plannedId = planif.id
          }
        })
      }
    },
    setNewCaption (state, payload) {
      if (payload.network === 'facebook') {
        state.post.facebook.inputText = payload.text
        state.post.facebook.alreadyGeneratedAI = true
      } else if (payload.network === 'instagram') {
        state.post.instagram.inputText = payload.text
        state.post.instagram.alreadyGeneratedAI = true
      } else if (payload.network === 'google') {
        state.post.google.inputText = payload.text
        state.post.google.alreadyGeneratedAI = true
      } else if (payload.network === 'linkedin') {
        state.post.linkedin.inputText = payload.text
        state.post.linkedin.alreadyGeneratedAI = true
      } else {
        propagateInitialTextToNetworks(state, payload.text)
        state.post.initial.inputText = payload.text
        state.post.initial.alreadyGeneratedAI = true
      }
      state.modalIA = false
    },
    deleteCaption (state, network) {
      if (network === 'facebook') {
        state.post.facebook.inputText = null
      } else if (network === 'instagram') {
        state.post.instagram.inputText = null
      } else if (network === 'google') {
        state.post.google.inputText = null
      } else if (network === 'linkedin') {
        state.post.linkedin.inputText = null
      } else {
        state.post.initial.inputText = null
      }
    },
    searchPhotosNetworksFromPost (state) {
      if (state.currentPost && state.currentPost.diffusions) {
        const diffusions = state.currentPost.diffusions
        forEach(diffusions, diffusion => {
          if (diffusion.advertiserPublication.portal.code === 'GOOGLE_MY_BUSINESS_EDITO') {
            state.post.google.pictures = diffusion.portalPictures
            if (diffusion.portalPictures.length > 0) { state.post.google.useAnotherPicture = true }
          }
          if (diffusion.advertiserPublication.portal.code === 'FACEBOOK_EDITO') {
            state.post.facebook.pictures = diffusion.portalPictures
            if (diffusion.portalPictures.length > 0) { state.post.facebook.useAnotherPicture = true }
          }
          if (diffusion.advertiserPublication.portal.code === 'INSTAGRAM_EDITO') {
            state.post.instagram.pictures = diffusion.portalPictures
            if (diffusion.portalPictures.length > 0) { state.post.instagram.useAnotherPicture = true }
          }
          if (diffusion.advertiserPublication.portal.code === 'LINKEDIN_EDITO') {
            state.post.linkedin.pictures = diffusion.portalPictures
            if (diffusion.portalPictures.length > 0) { state.post.linkedin.useAnotherPicture = true }
          }
        })
      }
    },
    setPostFromExisting (state) {
      if (!state.currentPost) {
        return
      }
      state.post.id = state.currentPost.id
      state.post.initial.libelle = state.currentPost.titre
      state.post.reference = state.currentPost.reference
      state.post.etat = state.currentPost.etat
      state.post.initial.studioSujetId = null
      state.post.initial.promptUtilisateur = null
      if (state.currentPost.donnees) {
        const donnees = state.currentPost.donnees
        const studioSujetDonnee = donnees.studio_sujet_id || donnees.STUDIO_SUJET_ID
        const studioSujetValue = studioSujetDonnee != null && typeof studioSujetDonnee === 'object' && studioSujetDonnee.valeur != null
          ? studioSujetDonnee.valeur
          : studioSujetDonnee
        if (studioSujetValue != null && studioSujetValue !== '') {
          state.post.initial.studioSujetId = String(studioSujetValue)
        }
        const promptDonnee = donnees.prompt_utilisateur || donnees.PROMPT_UTILISATEUR
        const promptValue = promptDonnee != null && typeof promptDonnee === 'object' && promptDonnee.valeur != null
          ? promptDonnee.valeur
          : promptDonnee
        if (promptValue != null && String(promptValue).trim() !== '') {
          state.post.initial.promptUtilisateur = String(promptValue).trim()
        }
      }
      if (state.currentPost.donnees && state.currentPost.donnees.UBIFLOW_ORIGIN_ID) {
        state.post.UBIFLOW_ORIGIN_ID = state.currentPost.UBIFLOW_ORIGIN_ID
      }
      if (state.currentPost.donnees && state.currentPost.donnees.caption) {
        state.post.initial.inputText = state.currentPost.donnees.caption.valeur
      }
      state.post.initial.pictures = state.currentPost.photos
      if (state.currentPost.donnees && state.currentPost.donnees.post_video_file_url_custom) {
        if (state.currentPost.donnees.post_video_file_url_custom.valeur && state.currentPost.donnees.post_video_file_url_custom.valeur.initial) {
          state.post.initial.linkToVideo = state.currentPost.donnees.post_video_file_url_custom.valeur.initial
        }
      }

      // Mettre à jour le statut des médias basé sur le currentPost
      // Réinitialiser les statuts
      state.statusMediasPost.hasPhotos = false
      state.statusMediasPost.hasVideoUrl = false
      state.statusMediasPost.hasVideoUpload = false

      // Vérifier les photos
      if (state.currentPost.photos && state.currentPost.photos.length > 0) {
        state.statusMediasPost.hasPhotos = true
      }

      // Vérifier les URLs vidéo personnalisées
      if (state.currentPost.donnees &&
            state.currentPost.donnees.post_video_file_url_custom &&
            state.currentPost.donnees.post_video_file_url_custom.valeur &&
            state.currentPost.donnees.post_video_file_url_custom.valeur.initial) {
        state.statusMediasPost.hasVideoUrl = true
      }

      // Vérifier les vidéos uploadées dans les assets
      const fluxDest = ''
      if (state.currentPost.assets &&
            state.currentPost.assets.VIDEO &&
            state.currentPost.assets.VIDEO[fluxDest] &&
            state.currentPost.assets.VIDEO[fluxDest].medias &&
            state.currentPost.assets.VIDEO[fluxDest].medias.length > 0) {
        state.statusMediasPost.hasVideoUpload = true
      }

      // Si on a une vidéo uploadée dans les assets, réinitialiser uploadedVideoPath
      if (state.currentPost.assets &&
            state.currentPost.assets.VIDEO &&
            state.currentPost.assets.VIDEO[fluxDest] &&
            state.currentPost.assets.VIDEO[fluxDest].medias &&
            state.currentPost.assets.VIDEO[fluxDest].medias.length > 0) {
        // Réinitialiser uploadedVideoPath car la vidéo est déjà sauvegardée dans le post
        state.uploadedVideoPath = null
      }

      if (state.currentPost.donnees && state.currentPost.donnees.caption && state.currentPost.donnees.caption.flux === 'ENRICHISSEMENT_IA') {
        state.post.initial.alreadyGeneratedAI = true
      }
      if (state.currentPost.donnees && state.currentPost.donnees.facebook_caption) {
        state.facebookChecked = true
        state.post.facebook.inputText = state.currentPost.donnees.facebook_caption.valeur
        if (state.post.facebook.inputText !== state.post.initial.inputText) {
          state.customFacebook = true
        }
        if (state.currentPost.donnees.post_action_button_label_custom && state.currentPost.donnees.post_action_button_label_custom.valeur && state.currentPost.donnees.post_action_button_label_custom.valeur.facebook) {
          state.customFacebook = true
          state.post.facebook.actionButton = state.currentPost.donnees.post_action_button_label_custom.valeur.facebook
        }
        if (state.currentPost.donnees.post_action_url_custom && state.currentPost.donnees.post_action_url_custom.valeur && state.currentPost.donnees.post_action_url_custom.valeur.facebook) {
          state.customFacebook = true
          state.post.facebook.urlAction = state.currentPost.donnees.post_action_url_custom.valeur.facebook
        }
        if (state.currentPost.donnees.urls_trackees_sur_site_annonceur && state.currentPost.donnees.urls_trackees_sur_site_annonceur.valeur && state.currentPost.donnees.urls_trackees_sur_site_annonceur.valeur.facebook) {
          state.customFacebook = true
          state.post.facebook.UTM = state.currentPost.donnees.urls_trackees_sur_site_annonceur.valeur.facebook
        }
        if (state.currentPost.donnees.caption && state.currentPost.donnees.caption.facebook_caption && state.currentPost.donnees.facebook_caption.flux === 'ENRICHISSEMENT_IA') {
          state.post.facebook.alreadyGeneratedAI = true
        }
        if (state.currentPost.donnees.post_video_file_url_custom && state.currentPost.donnees.post_video_file_url_custom.valeur && state.currentPost.donnees.post_video_file_url_custom.valeur.facebook) {
          state.post.facebook.linkToVideo = state.currentPost.donnees.post_video_file_url_custom.valeur.facebook
        }
      }
      if (state.currentPost.donnees && state.currentPost.donnees.instagram_caption) {
        state.instagramChecked = true
        state.post.instagram.inputText = state.currentPost.donnees.instagram_caption.valeur
        if (state.post.instagram.inputText !== state.post.initial.inputText) {
          state.customInstagram = true
        }
        if (state.currentPost.donnees.caption && state.currentPost.donnees.caption.instagram_caption && state.currentPost.donnees.instagram_caption.flux === 'ENRICHISSEMENT_IA') {
          state.post.instagram.alreadyGeneratedAI = true
        }
        if (state.currentPost.donnees.post_video_file_url_custom && state.currentPost.donnees.post_video_file_url_custom.valeur.instagram) {
          state.post.instagram.linkToVideo = state.currentPost.donnees.post_video_file_url_custom.valeur.instagram
        }
      }
      if (state.currentPost.donnees && state.currentPost.donnees.linkedin_commentary) {
        state.linkedInChecked = true
        state.post.linkedin.inputText = state.currentPost.donnees.linkedin_commentary.valeur
        if (state.post.linkedin.inputText !== state.post.initial.inputText) {
          state.customLinkedIn = true
        }
        if (state.currentPost.donnees.caption && state.currentPost.donnees.caption.linkedin_commentary && state.currentPost.linkedin_commentary.flux === 'ENRICHISSEMENT_IA') {
          state.post.linkedin.alreadyGeneratedAI = true
        }
        if (state.currentPost.donnees.post_video_file_url_custom && state.currentPost.donnees.post_video_file_url_custom.valeur && state.currentPost.donnees.post_video_file_url_custom.valeur.linkedin) {
          state.post.linkedin.linkToVideo = state.currentPost.donnees.post_video_file_url_custom.valeur.linkedin
        }
      }
      if (state.currentPost.donnees && state.currentPost.donnees.google_localpost_summary) {
        state.googleChecked = true
        state.post.google.inputText = state.currentPost.donnees.google_localpost_summary.valeur
        if (state.post.google.inputText !== state.post.initial.inputText) {
          state.customGoogle = true
        }
        if (state.currentPost.donnees.post_type_custom && state.currentPost.donnees.post_type_custom.valeur.GMB) {
          state.post.google.typePost = state.currentPost.donnees.post_type_custom.valeur.GMB
        }
        if (state.currentPost.donnees.offre_date_debut && state.currentPost.donnees.offre_date_debut.valeur) {
          state.customGoogle = true
          state.post.google.offerDateBefore = state.currentPost.donnees.offre_date_debut.valeur
        }
        if (state.currentPost.donnees.offre_date_fin && state.currentPost.donnees.offre_date_fin.valeur) {
          state.customGoogle = true
          state.post.google.offerDateAfter = state.currentPost.donnees.offre_date_fin.valeur
        }
        if (state.currentPost.donnees.urls_trackees_sur_site_annonceur && state.currentPost.donnees.urls_trackees_sur_site_annonceur.valeur.GMB) {
          state.customGoogle = true
          state.post.google.UTM = state.currentPost.donnees.urls_trackees_sur_site_annonceur.valeur.GMB
        }
        if (state.currentPost.donnees.post_action_url_custom && state.currentPost.donnees.post_action_url_custom.valeur && state.currentPost.donnees.post_action_url_custom.valeur.GMB) {
          state.customGoogle = true
          state.post.google.offerLink = state.currentPost.donnees.post_action_url_custom.valeur.GMB
        }
        if (state.currentPost.donnees.caption && state.currentPost.donnees.caption.google_localpost_summary && state.currentPost.google_localpost_summary.flux === 'ENRICHISSEMENT_IA') {
          state.post.google.alreadyGeneratedAI = true
        }
        if (state.currentPost.donnees.post_video_file_url_custom && state.currentPost.donnees.post_video_file_url_custom.valeur.google) {
          state.post.google.linkToVideo = state.currentPost.donnees.post_video_file_url_custom.valeur.google
        }
      }
    },
    setLoadingSendEmail (state, loadingSendEmail) {
      state.loadingSendEmail = loadingSendEmail
    },
    setPhotosForNetwork (state, { network, photos }) {
      if (network === 'initial') {
        state.post.initial.pictures = photos
      } else if (network === 'facebook') {
        state.post.facebook.pictures = photos
      } else if (network === 'instagram') {
        state.post.instagram.pictures = photos
      } else if (network === 'google') {
        state.post.google.pictures = photos
      } else if (network === 'linkedin') {
        state.post.linkedin.pictures = photos
      }
    },
    setFacebookPictures (state, photos) {
      state.post.facebook.pictures = photos
    },
    setInstagramPictures (state, photos) {
      state.post.instagram.pictures = photos
    },
    setGooglePictures (state, photos) {
      state.post.google.pictures = photos
    },
    setLinkedInPictures (state, photos) {
      state.post.linkedin.pictures = photos
    },
    setModalMediaImageAndVideo (state, bool) {
      state.modalMediaImageAndVideo = bool
    },
    setHasMediaConflict (state, hasConflict) {
      state.hasMediaConflict = hasConflict
    },
    setPendingActionType (state, pendingActionType) {
      state.pendingActionType = pendingActionType
    },
    setFacebookDatePlanif (state, datePlanif) {
      state.post.facebook.datePlanif = datePlanif
    },
    setInstagramDatePlanif (state, datePlanif) {
      state.post.instagram.datePlanif = datePlanif
    },
    setGoogleDatePlanif (state, datePlanif) {
      state.post.google.datePlanif = datePlanif
    },
    setLinkedInDatePlanif (state, datePlanif) {
      state.post.linkedin.datePlanif = datePlanif
    },
    setFacebookPublishNow (state, publishNow) {
      state.post.facebook.publishNow = publishNow
    },
    setInstagramPublishNow (state, publishNow) {
      state.post.instagram.publishNow = publishNow
    },
    setGooglePublishNow (state, publishNow) {
      state.post.google.publishNow = publishNow
    },
    setLinkedInPublishNow (state, publishNow) {
      state.post.linkedin.publishNow = publishNow
    },
    setStatusMediasPost (state, { key, value }) {
      // Forcer la conversion en booléen pour garantir le type
      state.statusMediasPost[key] = Boolean(value)
    },
    setUploadedVideoPath (state, path) {
      state.uploadedVideoPath = path
    },
    clearUploadedVideoPath (state) {
      state.uploadedVideoPath = null
    },
    setAnalyzingMedias (state, analyzing) {
      state.analyzingMedias = analyzing
    },
    setLastAnalyzedPostId (state, postId) {
      state.lastAnalyzedPostId = postId
    },
    setTemporaryVideosCache (state, { videos, timestamp }) {
      state.temporaryVideosCache = videos
      state.temporaryVideosCacheTime = timestamp
    },
    clearTemporaryVideosCache (state) {
      state.temporaryVideosCache = null
      state.temporaryVideosCacheTime = null
    }
  },
  actions: {
    resetCaption (context, payload) {
      context.commit('setLoadingStatusIAGeneration', true)
      const annonceId = context.getters.getId

      // 🔥 FIX: Extraire le network du payload car l'objet peut être {network: 'initial', annonceur: '...'}
      const network = payload.network || payload

      let url = baseURL + '/annonce-post'
      let diffuseur = ''
      switch (network) {
        case 'facebook':
          diffuseur = 'FACEBOOK_EDITO'
          break
        case 'instagram':
          diffuseur = 'INSTAGRAM_EDITO'
          break
        case 'google':
          diffuseur = 'GOOGLE_MY_BUSINESS_EDITO'
          break
        case 'linkedin':
          diffuseur = 'LINKEDIN_EDITO'
          break
      }

      if (diffuseur === '') {
        url = url + `?annonceId=${annonceId}`
      } else {
        url = url + `?annonceId=${annonceId}&diffuseurNomDeCode=${diffuseur}`
      }

      HTTP_HYPER_ESPACE_BACKEND.delete(url).then((response) => {
        if (response.status === 200) {
          context.commit('deleteCaption', network)
          return HTTP_HYPER_ESPACE_BACKEND.get(url).then(response => {
            context.commit('setNewCaption', { text: response.data.text, network: network })
          }).catch(error => {
            console.log({ type: 'error', message: error })
          })
        }
      }).catch(error => {
        return { type: 'error', message: error }
      })
        .finally(function () {
          context.commit('checkPublishButtonState')
          context.commit('checkDraftButtonState')
          context.commit('setLoadingStatusIAGeneration', false)
          context.commit('setModalIA', false)
        })
    },
    async generatePayload (context, payload) {
      const annonceur = store.state.app.user.username

      const data = {
        annonceur: {
          login: annonceur
        },
        flux: {
          code: 'SAISIE_EDITO'
        },
        networkHeadLogin: store.state.app.user.advertiserLogin,
        planifications: context.dispatch('generateScheduledEvents', { annonceur: store.state.app.user.advertiserLogin }),
        annonce: {
          caption: context.getters.getDefaultPost.initial.inputText || context.getters.getDefaultPost.initial.iaPrompt || 'Caption générée par IA',
          titre: context.getters.getDefaultPost.initial.libelle,
          code_type: 31000,
          type_offre: 'Q',
          STATUS: payload.typePost
        }
      }

      if (payload.videoDeleted) {
        data.actions = { videoDeleted: payload.videoDeleted }
      }

      if (context.getters.getDefaultPost.initial.iaPrompt) {
        data.annonce.post_ia_prompt = context.getters.getDefaultPost.initial.iaPrompt
      }
      const studioSujetId = context.getters.getDefaultPost.initial.studioSujetId
      if (studioSujetId != null && studioSujetId !== '') {
        data.annonce.STUDIO_SUJET_ID = Number(studioSujetId) || studioSujetId
      }
      const promptUtilisateur = context.getters.getDefaultPost.initial.promptUtilisateur
      if (promptUtilisateur != null && String(promptUtilisateur).trim() !== '') {
        data.annonce.PROMPT_UTILISATEUR = String(promptUtilisateur).trim()
      }
      if (context.getters.getPost.id) {
        data.id = context.getters.getPost.id
        data.annonce.reference = context.getters.getDefaultPost.reference
      }
      if (context.getters.getDefaultPost.facebook.actionButton || context.getters.getDefaultPost.google.actionButton) {
        data.annonce.post_action_button_label_custom = {}
      }
      if (context.getters.getDefaultPost.facebook.urlAction || context.getters.getDefaultPost.google.urlAction) {
        data.annonce.post_action_url_custom = {}
      }
      if (context.getters.getDefaultPost.facebook.iaPrompt || context.getters.getDefaultPost.google.iaPrompt || context.getters.getDefaultPost.instagram.iaPrompt || context.getters.getDefaultPost.linkedin.iaPrompt) {
        data.annonce.post_ia_prompt_custom = {}
      }
      if (context.getters.getMustUpdateDestination) {
        data.mustUpdateDestination = true
      }
      data.portalPictures = {}

      // Traitement des photos initiales
      const initialPictures = context.getters.getDefaultPost.initial.pictures
      if (initialPictures && initialPictures.length > 0) {
        data.pictures = await context.dispatch('processPhotos', {
          photos: initialPictures,
          network: 'initial'
        })
      } else {
        // S'assurer que pictures existe toujours, même vide, pour éviter l'erreur backend
        data.pictures = []
      }

      if (!data.annonce.post_video_file_url_custom) {
        data.annonce.post_video_file_url_custom = {}
      }

      data.annonce.post_video_file_url_custom.initial = context.getters.getDefaultPost.initial.linkToVideo

      if (context.getters.getDefaultPost.initial.iaPrompt) {
        data.annonce.post_ia_prompt = context.getters.getDefaultPost.initial.iaPrompt
      }

      // Traitement des photos pour chaque réseau
      if (context.getters.getFacebookChecked) {
        data.annonce.facebook_caption = context.getters.getDefaultPost.facebook.inputText
        if (context.getters.getDefaultPost.facebook.actionButton) {
          data.annonce.post_action_button_label_custom.facebook = context.getters.getDefaultPost.facebook.actionButton
        }
        if (context.getters.getDefaultPost.facebook.urlAction) {
          data.annonce.post_action_url_custom.facebook = context.getters.getDefaultPost.facebook.urlAction
        }
        if (context.getters.getDefaultPost.facebook.iaPrompt) {
          data.annonce.post_ia_prompt_custom.FACEBOOK = context.getters.getDefaultPost.facebook.iaPrompt
        }
        const facebookPictures = context.getters.getDefaultPost.facebook.pictures
        if (facebookPictures && facebookPictures.length > 0) {
          data.portalPictures.FACEBOOK_EDITO = await context.dispatch('processPhotos', {
            photos: facebookPictures,
            network: 'facebook'
          })
        }
        if (context.getters.getDefaultPost.facebook.linkToVideo) {
          data.annonce.post_video_file_url_custom.facebook = context.getters.getDefaultPost.facebook.linkToVideo
        }
      }
      if (context.getters.getGoogleChecked) {
        data.annonce.google_localpost_summary = context.getters.getDefaultPost.google.inputText
        if (context.getters.getDefaultPost.google.actionButton) {
          data.annonce.post_action_button_label_custom.google = context.getters.getDefaultPost.google.actionButton
        }
        if (context.getters.getDefaultPost.google.urlAction) {
          data.annonce.post_action_url_custom.google = context.getters.getDefaultPost.google.urlAction
        }
        if (context.getters.getDefaultPost.google.iaPrompt) {
          data.annonce.post_ia_prompt_custom.GMB = context.getters.getDefaultPost.google.iaPrompt
        }
        const googlePictures = context.getters.getDefaultPost.google.pictures
        if (googlePictures && googlePictures.length > 0) {
          data.portalPictures.GOOGLE_MY_BUSINESS_EDITO = await context.dispatch('processPhotos', {
            photos: googlePictures,
            network: 'google'
          })
        }
        if (context.getters.getDefaultPost.google.linkToVideo) {
          data.annonce.post_video_file_url_custom.google = context.getters.getDefaultPost.google.linkToVideo
        }
      }
      if (context.getters.getInstagramChecked) {
        data.annonce.instagram_caption = context.getters.getDefaultPost.instagram.inputText
        if (context.getters.getDefaultPost.google.iaPrompt) {
          data.annonce.post_ia_prompt_custom.INSTAGRAM = context.getters.getDefaultPost.instagram.iaPrompt
        }
        const instagramPictures = context.getters.getDefaultPost.instagram.pictures
        if (instagramPictures && instagramPictures.length > 0) {
          data.portalPictures.INSTAGRAM_EDITO = await context.dispatch('processPhotos', {
            photos: instagramPictures,
            network: 'instagram'
          })
        }
        if (context.getters.getDefaultPost.instagram.linkToVideo) {
          data.annonce.post_video_file_url_custom.instagram = context.getters.getDefaultPost.instagram.linkToVideo
        }
      }
      if (context.getters.getLinkedInChecked) {
        data.annonce.linkedin_commentary = context.getters.getDefaultPost.linkedin.inputText
        if (context.getters.getDefaultPost.linkedin.iaPrompt) {
          data.annonce.post_ia_prompt_custom.LINKEDIN = context.getters.getDefaultPost.linkedin.iaPrompt
        }
        const linkedinPictures = context.getters.getDefaultPost.linkedin.pictures
        if (linkedinPictures && linkedinPictures.length > 0) {
          data.portalPictures.LINKEDIN_EDITO = await context.dispatch('processPhotos', {
            photos: linkedinPictures,
            network: 'linkedin'
          })
        }
        if (context.getters.getDefaultPost.linkedin.linkToVideo) {
          data.annonce.post_video_file_url_custom.linkedin = context.getters.getDefaultPost.linkedin.linkToVideo
        }
      }

      data.planifications = await context.dispatch('generateScheduledEvents', { annonce: data.annonce })
      return data
    },
    generateScheduledEvents (context, payload) {
      const defaultCronExpression = '* * * * *'
      const post = context.getters.getPost
      const request = {}
      const planifications = []
      request.id = post.id
      request.cronExpression = defaultCronExpression

      // Si c'est un brouillon (type B), on ne génère pas de planifications
      if (payload && payload.annonce && payload.annonce.STATUS === 'B') {
        return []
      }

      if (context.getters.getFacebookChecked && !post.facebook.alreadyPublished) {
        if (post.facebook.datePlanif) {
          planifications.push({
            code: 'FACEBOOK_EDITO',
            cronExpression: generateCronExpression(post.facebook.datePlanif)
          })
        } else {
          planifications.push({
            code: 'FACEBOOK_EDITO',
            cronExpression: defaultCronExpression
          })
        }
      }
      if (context.getters.getInstagramChecked && !post.instagram.alreadyPublished) {
        if (post.instagram.datePlanif) {
          planifications.push({
            code: 'INSTAGRAM_EDITO',
            cronExpression: generateCronExpression(post.instagram.datePlanif)
          })
        } else {
          planifications.push({
            code: 'INSTAGRAM_EDITO',
            cronExpression: defaultCronExpression
          })
        }
      }
      if (context.getters.getGoogleChecked && !post.google.alreadyPublished) {
        if (post.google.datePlanif) {
          planifications.push({
            code: 'GOOGLE_MY_BUSINESS_EDITO',
            cronExpression: generateCronExpression(post.google.datePlanif)
          })
        } else {
          planifications.push({
            code: 'GOOGLE_MY_BUSINESS_EDITO',
            cronExpression: defaultCronExpression
          })
        }
      }
      if (context.getters.getLinkedInChecked && !post.linkedin.alreadyPublished) {
        if (post.linkedin.datePlanif) {
          planifications.push({
            code: 'LINKEDIN_EDITO',
            cronExpression: generateCronExpression(post.linkedin.datePlanif)
          })
        } else {
          planifications.push({
            code: 'LINKEDIN_EDITO',
            cronExpression: defaultCronExpression
          })
        }
      }

      return planifications
    },
    loadSocialPostEditorialById (context, id) {
      context.commit('setLoadingStatus', true)

      let url = baseURL + '/social-management-posts?universe=EDITO&annonceId=' + id
      const codenamesCall = formatCodenamesCall(null, true, true)

      const codenames = codenamesCall[0]

      url = url + '&portalCodesAnnonces=' + codenames
      codenamesCall[1].forEach(function (element) {
        url = url + '&linkedPortals[]=' + element
      })
      const posts = HTTP_HYPER_ESPACE_BACKEND
        .get(url)
        .then(response => {
          context.commit('setCurrentPost', response.data.annonces[0])
          context.commit('setPlanifications', response.data.annonces[0].planifications)
          context.commit('setDiffusions', response.data.annonces[0].diffusions)
          context.commit('setPostFromExisting')
          context.commit('searchPhotosNetworksFromPost')
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
        .finally(function () {
          context.commit('checkPlanned')
          context.commit('checkPublished')
          context.commit('checkPublishButtonState')
          context.commit('checkDraftButtonState')
          context.commit('setLoadingStatus', false)
        })
    },
    async generateIA (context, network) {
      context.commit('setLoadingStatusIAGeneration', true)
      try {
        const response = await HTTP_HYPER_ESPACE_BACKEND.get(`/annonce-post?annonceId=${context.getters.getPost.id}&diffuseurNomDeCode=${network.toUpperCase()}_EDITO`)
        context.commit('setNewCaption', { network, text: response.data.text })
        context.commit('setModalIA', false)
      } catch (error) {
        message.error(`Erreur : ${error}`)
        context.commit('setModalIA', false)
        throw error
      } finally {
        context.commit('setLoadingStatusIAGeneration', false)
      }
    },
    handleScheduled (context, payload) {
      const cronExpression = '* * * * *'
      const post = context.getters.getPost
      let newDate = null
      const request = {}
      request.id = post.id
      request.cronExpression = cronExpression
      if (payload.network === 'facebook') {
        if (post.facebook.datePlanif) {
          newDate = new Date(post.facebook.datePlanif)
        }
        if (post.facebook.plannedId) {
          request.idPlanif = post.facebook.plannedId
        }
        request.codenameNetwork = 'FACEBOOK_EDITO'
      }
      if (payload.network === 'instagram') {
        if (post.instagram.datePlanif) {
          newDate = new Date(post.instagram.datePlanif)
        }
        if (post.instagram.plannedId) {
          request.idPlanif = post.instagram.plannedId
        }
        request.codenameNetwork = 'INSTAGRAM_EDITO'
      }
      if (payload.network === 'linkedin') {
        if (post.linkedin.datePlanif) {
          newDate = new Date(post.linkedin.datePlanif)
        }
        if (post.linkedin.plannedId) {
          request.idPlanif = post.linkedin.plannedId
        }
        request.codenameNetwork = 'LINKEDIN_EDITO'
      }
      if (payload.network === 'google') {
        if (post.google.datePlanif) {
          newDate = new Date(post.google.datePlanif)
        }
        if (post.google.plannedId) {
          request.idPlanif = post.google.plannedId
        }
        request.codenameNetwork = 'GOOGLE_MY_BUSINESS_EDITO'
      }
      if (newDate) {
        request.cronExpression = generateCronExpression(newDate)
      }
      context.dispatch('handleRequest', request)
    },
    handleRequest (context, payload) {
      const idAnnonceur = store.getters.getSitimmoUser.id
      const login = store.getters.getSitimmoUser.login
      const payloadToApi = {
        annonceurId: idAnnonceur,
        annonceurLogin: login,
        annonces: [parseInt(payload.id)],
        type: 'MANUEL',
        scheduled: {
          cronExpression: payload.cronExpression,
          status: '1'
        },
        cancelBy: null,
        portails: [{ code: payload.codenameNetwork, value: null }]
      }

      const url = baseURL + '/socialposts'

      if (payload.idPlanif) {
        const idPlanif = payload.idPlanif
        const payloadDelete = {
          data: {
            id: idPlanif
          }
        }
        const replyDelete = HTTP_HYPER_ESPACE_BACKEND
          .delete(url, payloadDelete)
          .then(response => {
          })
          .catch(error => {
            message.error('Erreur : ' + error)
            return {
              type: 'error',
              message: error
            }
          })
          .finally(function () {

          })
      }

      const reply = HTTP_HYPER_ESPACE_BACKEND
        .post(url, payloadToApi)
        .then(response => {
        })
        .catch(error => {
          console.log('Erreur : ' + error)
          // message.error('Erreur : ' + error)
          return {
            type: 'error',
            message: error
          }
        })
        .finally(function () {

        })
    },
    async handlePublish (context) {
      context.commit('setLoadingStatus', true)
      try {
        await context.dispatch('validatePost', { typePost: 'A', publish: true })
      } catch (error) {
        console.error('Erreur lors de la publication:', error)
        throw error
      } finally {
        context.commit('setLoadingStatus', false)
      }
    },
    async processPhotos (context, { photos, network }) {
      context.commit('setLoadingStatus', true)
      try {
        // Nettoyer les photos en base64
        if (!photos || photos.length === 0) return []

        const processedPhotos = await Promise.all(photos.map(async (photo) => {
          const processedPhoto = { ...photo }

          if (photo.type && photo.type === 'base64') {
            processedPhoto.value = photo.url.replace(/^data:image\/[^;]+;base64,/, '')
          } else {
            processedPhoto.type = 'base64'
            processedPhoto.value = photo.chaine_source
            delete processedPhoto.nom_source
            delete processedPhoto.chaine_source
          }

          delete processedPhoto.url
          delete processedPhoto.url_miniature

          return processedPhoto
        }))

        // Ne pas écraser le store : les photos UI conservent leur url (notamment après regénération IA)
        context.commit('setLoadingStatus', false)
        return processedPhotos
      } catch (error) {
        context.commit('setLoadingStatus', false)
        throw error
      }
    },
    /**
     * Logique unique « Rédiger avec l’IA » (ex-PostEditoCreateModalIA.generatePostIA) : prompt store + validatePost.
     * @param {{ network: string, initialIaPrompt?: string, studioSujetId?: string|number, promptUtilisateur?: string }} payload
     */
    dispatchEditorialIaGeneration (context, { network, initialIaPrompt, studioSujetId, promptUtilisateur }) {
      context.commit('setLoadingStatusIAGeneration', true)
      const post = context.state.post
      if (studioSujetId != null && studioSujetId !== '') {
        context.commit('setStudioSujetContext', {
          studioSujetId,
          promptUtilisateur: promptUtilisateur || ''
        })
      } else {
        context.commit('clearStudioSujetContext')
      }
      if (network === 'initial') {
        if (studioSujetId != null && studioSujetId !== '') {
          context.commit('setInitialIAPrompt', '')
        } else {
          const prompt = initialIaPrompt !== undefined && initialIaPrompt !== null
            ? initialIaPrompt
            : post.initial.iaPrompt
          context.commit('setInitialIAPrompt', prompt)
        }
      } else if (network === 'facebook') {
        context.commit('setFacebookIAPrompt', post.facebook.iaPrompt)
      } else if (network === 'google') {
        context.commit('setGoogleIAPrompt', post.google.iaPrompt)
      } else if (network === 'instagram') {
        context.commit('setInstagramIAPrompt', post.instagram.iaPrompt)
      } else if (network === 'linkedin') {
        context.commit('setLinkedInIAPrompt', post.linkedin.iaPrompt)
      }
      const create = context.state.create
      const hasPostId = Boolean(context.getters.getId)
      if (create && !hasPostId) {
        if (!context.state.post.initial.inputText) {
          context.commit('setInitialInputText', context.state.post.initial.iaPrompt)
        }
        context.dispatch('validatePost', { typePost: 'B', generateIA: true, network })
      } else {
        context.dispatch('validatePost', { generateIA: true, network })
      }
      context.commit('checkPublishButtonState')
      context.commit('checkDraftButtonState')
    },
    async validatePost (context, payload) {
      // console.log(payload)
      context.commit('setLoadingStatus', true)
      if (payload.generateIA) {
        context.commit('setLoadingStatusIAGeneration', true)
      }
      const post = await context.dispatch('generatePayload', payload)

      const url = '/socialposts/post/treatment'
      return HTTP_HYPER_ESPACE_BACKEND.post(url, post)
        .then(response => {
          context.commit('setId', response.data.ad.id)
          context.commit('setReferencePost', response.data.ad.reference)
          context.commit('setEdit', true)
          context.commit('setCreate', false)
          if (payload.generateIA) {
            context.dispatch('resetCaption', { network: payload.network, annonceur: response.data.ad.advertiser.login })
          }
          context.commit('searchPhotosNetworksFromPost')
        })
        .catch(error => {
          // console.log('Erreur : ' + error)
          return {
            type: 'error',
            message: error
          }
        })
        .finally(function () {
          context.commit('setLoadingStatus', false)
          // Mettre redirection à true pour tous les cas sauf quand on génère l'IA
          // (car dans ce cas on reste sur la page pour voir le résultat)
          if (!payload.generateIA && !payload.videoDeleted) {
            context.commit('setRedirection', true)
          }
          // Pour les modèles, on doit aussi mettre redirection à true même s'il y a génération IA
          // car le processus de sauvegarde est terminé
          if (payload.typePost === 'M') {
            context.commit('setRedirection', true)
          }
        })
    },
    deletePlanif (context) {
      const post = context.getters.getPost
      const url = '/socialposts'
      if (post.planifications && post.planifications.length > 0) {
        const planifs = post.planifications
        planifs.forEach((planif, index) => {
          const payloadDelete = {
            data: {
              id: planif.id,
              annonceurId: planif.annonceurId,
              annonceurLogin: planif.annonceurLogin
            }
          }
          const replyDelete = HTTP_HYPER_ESPACE_BACKEND.delete(url, payloadDelete)
            .then(response => {
            })
            .catch(error => {
              // console.log('Erreur : ' + error)
              // message.error('Erreur : ' + error)
              return {
                type: 'error',
                message: error
              }
            })
            .finally(function () {

            })
        })
      }
    },
    sendEmailEnableNetwork (context, payload) {
      context.commit('setLoadingSendEmail', true)
      const sitimmoUser = store.getters.getSitimmoUser
      const mailData = {
        to: processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_RC,
        subject: 'Post éditorial : Demande de branchement depuis l\'espace client' + ' - ' + sitimmoUser.login,
        content: 'Bonjour,\n' +
          'L\'annonceur ' + sitimmoUser.login + ' (https://gestionnaire.ubiflow.net/fr/annonceurs/annonceur/' + sitimmoUser.id + ') souhaite gérer ses posts éditoriaux pour sa page ' + payload + ' depuis son Espace Client.\n' +
          'Merci de prendre contact avec lui.' + ' Bonne journée'
      }

      sendEmail(mailData).then(r => message({ message: 'Votre demande a bien été envoyée. Notre équipe va revenir vers vous dans les meilleurs délais.', type: 'success' }))
      context.commit('setLoadingSendEmail', false)
    },
    setDraft (context, payload) {
      const data = {}
      data.annonceur = {
        login: store.getters.getSitimmoUser.login
      }
      data.flux = {
        code: 'SAISIE_EDITO'
      }
      data.annonce = {}
      data.STATUS = 'B'
      const url = baseURL + '/annonce'

      const draft = HTTP_HYPER_ESPACE_BACKEND
        .patch(url + '/' + context.getters.getId, data)
        .then(response => {
          return { type: 'success', message: 'OK' }
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
    },
    deletePostEditorial (context, payload) {
      context.commit('setLoadingStatus', true)
      const params = {
        data: [payload]
      }
      const url = '/annonce'
      return HTTP_HYPER_ESPACE_BACKEND
        .delete(url, params)
        .then(response => {
          return { type: 'success', message: 'OK' }
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
        .finally(function () {
          context.commit('setLoadingStatus', false)
          // console.log('deleted')
        })
    },
    createPostFromModel (context, payload) {
      context.commit('setLoadingStatus', true)
      const data = {
        id: payload.id,
        reference: payload.reference
      }

      if (payload.fromReseau) {
        data.dstAnnonceur = store.getters.getSitimmoUser.id
      }

      return HTTP_HYPER_ESPACE_BACKEND
        .post('/createPostFromModel', data)
        .then(response => {
          context.commit('setCurrentPost', response.data.ad)
          context.commit('setPlanifications', response.data.ad)
          context.commit('setDiffusions', response.data.ad)
          context.commit('setPostFromExisting')
          context.commit('setId', response.data.ad.id)
          context.commit('checkPublishButtonState')
          context.commit('checkDraftButtonState')
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
        .finally(() => {
          context.commit('setLoadingStatus', false)
        })
    },

    // Action pour vérifier les vidéos temporaires avec cache
    async checkTemporaryVideos ({ commit, state }) {
      const now = Date.now()
      const cacheValidityDuration = 30000 // 30 secondes de cache

      // Vérifier si le cache est encore valide
      if (state.temporaryVideosCache !== null &&
          state.temporaryVideosCacheTime &&
          (now - state.temporaryVideosCacheTime) < cacheValidityDuration) {
        return state.temporaryVideosCache
      }

      try {
        const response = await HTTP_HYPER_ESPACE_BACKEND.get('/videos')
        const videosData = {
          count: response.data.count,
          videos: response.data.videos || []
        }

        // Mettre en cache le résultat
        commit('setTemporaryVideosCache', {
          videos: videosData,
          timestamp: now
        })

        return videosData
      } catch (error) {
        // Mettre en cache un résultat vide
        const emptyResult = { count: 0, videos: [] }
        commit('setTemporaryVideosCache', {
          videos: emptyResult,
          timestamp: now
        })

        return emptyResult
      }
    },

    // Nouvelle action centralisée pour analyser tous les médias
    async analyzePostMedias ({ commit, state, dispatch }, postId) {
      // Protection contre les appels multiples
      if (state.analyzingMedias) {
        return state.statusMediasPost
      }

      // Protection contre l'analyse répétée du même post (sauf si pas de postId pour création)
      if (postId && state.lastAnalyzedPostId === postId) {
        return state.statusMediasPost
      }

      commit('setAnalyzingMedias', true)

      try {
        // Reset des statuts
        commit('setStatusMediasPost', { key: 'hasPhotos', value: false })
        commit('setStatusMediasPost', { key: 'hasVideoUrl', value: false })
        commit('setStatusMediasPost', { key: 'hasVideoUpload', value: false })

        const currentPost = state.currentPost

        // Pour la création de nouveaux posts, currentPost peut être null
        if (postId && (!currentPost || currentPost.id !== postId)) {
          console.warn('Post non chargé ou ID différent (éditorial), mais on continue l\'analyse pour les vidéos temporaires')
        }

        // 1. Vérifier les photos
        const hasPhotos = (currentPost && currentPost.photos && currentPost.photos.length > 0) ||
                         (state.post.initial.pictures && state.post.initial.pictures.length > 0)
        if (hasPhotos) {
          commit('setStatusMediasPost', { key: 'hasPhotos', value: true })
        }

        // 2. Vérifier les URLs vidéo
        let hasVideoUrl = false
        if (state.post.initial.linkToVideo && state.post.initial.linkToVideo.trim() !== '') {
          hasVideoUrl = true
        }

        if (hasVideoUrl) {
          commit('setStatusMediasPost', { key: 'hasVideoUrl', value: true })
        }

        const fluxDest = ''
        // 3. Vérifier les vidéos uploadées dans le post
        const hasVideoInPost = currentPost &&
            currentPost.assets &&
            currentPost.assets.VIDEO &&
            currentPost.assets.VIDEO[fluxDest] &&
            currentPost.assets.VIDEO[fluxDest].medias &&
            currentPost.assets.VIDEO[fluxDest].medias.length > 0

        // 4. Vérifier les vidéos temporaires uploadées (avec cache)
        const temporaryVideosData = await dispatch('checkTemporaryVideos')
        const hasTemporaryVideo = temporaryVideosData.count > 0

        if (hasTemporaryVideo) {
          const video = temporaryVideosData.videos[0]
          commit('setUploadedVideoPath', video.path)
        } else {
          commit('clearUploadedVideoPath')
        }

        // Mettre à jour le statut vidéo upload (post ou temporaire)
        if (hasVideoInPost || hasTemporaryVideo) {
          commit('setStatusMediasPost', { key: 'hasVideoUpload', value: true })
        }

        return state.statusMediasPost
      } catch (error) {
        return state.statusMediasPost
      } finally {
        commit('setAnalyzingMedias', false)
        commit('setLastAnalyzedPostId', postId)
      }
    },

    // Action pour invalider le cache des vidéos temporaires
    invalidateTemporaryVideosCache ({ commit }) {
      commit('clearTemporaryVideosCache')
      // Aussi réinitialiser le flag d'analyse pour permettre une nouvelle analyse
      commit('setLastAnalyzedPostId', null)
    },

    // Action utilitaire pour déclencher manuellement l'analyse des médias
    async refreshMediaAnalysis ({ dispatch, state }) {
      // Invalider le cache avant l'analyse
      dispatch('invalidateTemporaryVideosCache')

      if (state.currentPost && state.currentPost.id) {
        return await dispatch('analyzePostMedias', state.currentPost.id)
      } else {
        // Pour les nouveaux posts en création, analyser sans postId
        return await dispatch('analyzePostMedias', null)
      }
    }
  }
}
